var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Pay Analytics","icon":"money-bill-wave","css-class":"analytics-pay","default-label":"Pay","section-specs":_setup.sectionSpecs}},[_c(_setup.StreamMetrics,{ref:"streamRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }